export {
  detectDocumentType,
  sanitizeDocument,
  validateCPF,
  validateCNPJ,
  validateDocument,
  formatDocument,
  formatCPF,
  formatCNPJ,
} from "./document";

/**
 * Masks a CPF for display, showing only the last 2 digits.
 * Example: "123.456.789-00" → "***.***.*89-00"
 */
export const maskCPF = (cpf: string): string => {
  const clean = cpf.replace(/\D/g, '');
  if (clean.length < 11) return cpf;
  return `***.***.*${clean.slice(7, 9)}-${clean.slice(9)}`;
};

/**
 * Digits-only BR phone for storage/API (orders, profiles, tickets, Asaas).
 * Strips leading country code 55 when present (12–13 digits).
 */
export const normalizePhoneDigits = (value: string | null | undefined): string => {
  let clean = String(value || "").replace(/\D/g, "");
  if ((clean.length === 12 || clean.length === 13) && clean.startsWith("55")) {
    clean = clean.slice(2);
  }
  return clean.slice(0, 11);
};

/**
 * Formats a phone number as (00) 00000-0000
 */
export const formatPhone = (value: string): string => {
  const clean = normalizePhoneDigits(value);
  if (clean.length <= 2) return clean;
  if (clean.length <= 7) return `(${clean.slice(0, 2)}) ${clean.slice(2)}`;
  return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7)}`;
};
